import { Component, Vue, Model } from "vue-property-decorator";
import { Option } from '@/models/Option';
import { matArrowDropDown } from "@quasar/extras/material-icons";
import { translate } from "@/utils/translation";

@Component
  export default class ProductCategorySelector extends Vue {

    public store = this.$store.direct;
    private matArrowDropDown!: string;

    public created() {
        this.matArrowDropDown = matArrowDropDown;
    }

    private get categoryOptions(): Array<any> {
        if (!this.store.state.selectorStateModule.availableCategories) {
          return [];
        }
        return (this.store.state.selectorStateModule.availableCategories as Array<Option>).map(category => ({
            label: category.Label,
            value: category.Value,
            selected: category.Selected
        }));
    }

    private get selectedCategory() {
        return this.store.getters.selectorStateModule.getSelectedCategory;
    }

    private set selectedCategory(value: any) {
        this.store.dispatch.selectorStateModule.selectCategory({ categoryId: value });
    }

    private get productOptions() {
        return this.store.getters.selectorStateModule.getAvailableProducts;
    }

    private get selectedProduct() {
        return this.store.getters.selectorStateModule.getAvailableProducts.find(x => x.value === this.store.state.selectorStateModule.selectedProduct);
    }

    private set selectedProduct(value: string) {
        this.store.commit.selectorStateModule.SELECT_PRODUCT(value);
    }

    public Translate(text: string) {
        return translate(text);
    }
  }